export const SET_ANALYSIS_IS_PROCESSING = 'SET_ANALYSIS_IS_PROCESSING';
export const SET_ANALYSIS_PROCESSING_STEP = 'SET_ANALYSIS_PROCESSING_STEP';
export const SET_ANALYSIS_SELECTED_CAROUSEL_STIMULI = 'SET_ANALYSIS_SELECTED_CAROUSEL_STIMULI';

export const SET_ANALYSIS_DATASET = 'SET_ANALYSIS_DATASET';

export const RESET_ALL_ANALYSIS_DATA = 'RESET_ALL_ANALYSIS_DATA';
export const SET_ANALYSIS_VIDEO_DATA = 'SET_ANALYSIS_VIDEO_DATA';
export const SET_ANALYSIS_HEATMAPS_DATA = 'SET_ANALYSIS_HEATMAPS_DATA';
export const SET_ANALYSIS_JOURNEYMAP_DATA = 'SET_ANALYSIS_JOURNEYMAP_DATA';
export const SET_ANALYSIS_AGGREGATE_JOURNEYMAP_DATA = 'SET_ANALYSIS_AGGREGATE_JOURNEYMAP_DATA';
export const SET_ANALYSIS_CIRCUMPLEX_DATA = 'SET_ANALYSIS_CIRCUMPLEX_DATA';

export const SET_ANALYSIS_PROJECT_ID_LISTEN_SOCKET = 'SET_ANALYSIS_PROJECT_ID_LISTEN_SOCKET';
export const SET_ANALYSIS_LAYERS = 'SET_ANALYSIS_PARTICIPANTS';
export const SET_ANALYSIS_LAYERS_SORTING = 'SET_ANALYSIS_LAYERS_ORDER';
export const SET_ANALYSIS_ACTIVE_LAYER = 'SET_ANALYSIS_ACTIVE_LAYER';
export const SET_ANALYSIS_VISIBLE_LAYERS = 'SET_ANALYSIS_VISIBLE_LAYERS';

export const SET_ANALYSIS_ACTIVE_ABSTRACT_TYPE = 'SET_ANALYSIS_ACTIVE_ABSTRACT_TYPE';
export const SET_ANALYSIS_SIGNALS_COLORS = 'SET_ANALYSIS_SIGNALS_COLORS';
export const SET_ANALYSIS_SIGNALS_SORTING = 'SET_ANALYSIS_SIGNALS_SORTING';
export const SET_ANALYSIS_SIGNAL_DIMENSIONS_SORTING = 'SET_ANALYSIS_SIGNAL_DIMENSIONS_SORTING';
export const SET_ANALYSIS_SIGNALS = 'SET_ANALYSIS_SIGNALS';

export const SET_ANALYSIS_PARTICIPATIONS = 'SET_ANALYSIS_PARTICIPATIONS';
export const SET_ANALYSIS_GROUP_PARTICIPATIONS = 'SET_ANALYSIS_GROUP_PARTICIPATIONS';

export const RESET_ANALYSIS_SECTION = 'RESET_ANALYSIS_SECTION';

export const SET_ANALYSIS_STIMULI_SORTING = 'SET_ANALYSIS_STIMULI_SORTING';
export const SET_ANALYSIS_EVENTS_SORTING = 'SET_ANALYSIS_EVENTS_SORTING';

export const SET_ANALYSIS_STIMULI = 'SET_ANALYSIS_STIMULI';
export const SET_ANALYSIS_EVENTS = 'SET_ANALYSIS_EVENTS';

export const SET_ANALYSIS_MODES = 'SET_ANALYSIS_MODES';
export const SET_PROJECT_EXPORTS = 'SET_PROJECT_EXPORTS';

export const SET_ANNOTATION_LIST = 'SET_ANNOTATIONS_LIST';


// WEBPACK FOOTER //
// ./src/scenes/analysis/data/analysis/consts.js